import { render } from "./HeroAuthDashboardHeader.vue?vue&type=template&id=5076ef57&scoped=true"
import script from "./HeroAuthDashboardHeader.vue?vue&type=script&lang=js"
export * from "./HeroAuthDashboardHeader.vue?vue&type=script&lang=js"

import "./HeroAuthDashboardHeader.vue?vue&type=style&index=0&id=5076ef57&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5076ef57"]])

export default __exports__